import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../components/Intl/WithIntl';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardImg, CardImgOverlay, Jumbotron, ButtonGroup, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import config from '../../../config';

import { checkVersionRequest } from '../../App/AppActions';

import PageWrapper from '../../../components/Content/PageWrapper';
import AppLogo from '../../App/components/view/AppLogo';
import Chrono from '../../../components/Time/Chrono';
import CmsPanel from '../../Cms/components/content/CmsPanel';

function UpdatePage({ dispatch, intl }) {
    const UPDATE_REFRESH_INTERVAL = 1;
    // Refresh page every UPDATE_REFRESH_INTERVAL minutes to check if update is finished
    setInterval(() => {
        dispatch(checkVersionRequest(true)).then(res => {
            typeof window !== 'undefined' && window.location.reload();
        });
    }, UPDATE_REFRESH_INTERVAL * 60 * 1000);

    return (
        <Container className="page-wrapper mt-5 bg-company text-center">
            <PageWrapper>
                <AppLogo suffix="alt" />
                <Card className="mt-5 mb-5 shadow text-center">
                    <CardHeader>
                        <CardTitle>
                            <FontAwesomeIcon icon="info-circle" /> <FormattedMessage id="appUpdateTitle" defaultMessage="App is updating..." />
                        </CardTitle>
                    </CardHeader>
                    <CardBody className="px-3">
						<CmsPanel 
							slug="maintenance-disclaimer"
							defaultDisplay={(
								<FormattedMessage id="appUpdateText" defaultMessage="The app is currently updating, it will take few minutes... This page will refresh after update completed." />
							)}
						/>
						<br />
                        <h4 className="text-info"><Chrono date={moment().add(UPDATE_REFRESH_INTERVAL, 'minute')} /></h4>
                    </CardBody>
                    <CardImg src="/assets/images/illustration-update.jpg" alt={intl.formatMessage({ id: 'appUpdateTitle', defaultMessage: 'App is updating...' })} />
                </Card>
            </PageWrapper>
        </Container>
    );
}

UpdatePage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default connect()(withIntl(UpdatePage));
